import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  Button,
  CircularProgress,
  Typography, Snackbar,
  Paper,
  Zoom,
  Fab,
  Tooltip,
  Menu,
  withStyles,
  useTheme,
} from '@material-ui/core';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import UpArrow from '@material-ui/icons/ArrowUpward';
import Add from '@material-ui/icons/Add';
import ShareIcon from '@material-ui/icons/Share';
import { createMarkup, prettifyDate, constructShareLink } from '../../shared/Helpers';

import ShareDialog from '../ShareDialog';
import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import { getBlogPostByIdOrSlug } from '../../shared/requests/BlogRequests';
import {
  postShape,
  postShapeIsRequired,
  postDefaultProps,
  locationdefaultProps,
  matchDefaultProps,
  matchShape,
  locationShape,
} from './propShapes';


const styles = theme => ({
  loadingSpinner: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#fafafa',
  },
  container: {
    width: 'auto',
    maxWidth: '800px',
    marginRight: '295px',
    marginLeft: 'auto',
    [theme.breakpoints.up(1380 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    [theme.breakpoints.down(1110)]: {
      marginLeft: theme.spacing(2),
    },
    [theme.breakpoints.down(850)]: {
      width: '100%',
      marginLeft: '0px',
      marginRight: '0px',
    },
  },
  hero: {
    height: 'auto',
    width: '100%',
    alignItems: 'center',
    borderRadius: '4px',
  },
  header: {
    fontWeight: 650,
    marginTop: theme.spacing(2),
    fontSize: 'calc(10px + 4vmin)',
  },
  subHeader: {
    textAlign: 'center',
  },
  paper: {
    // marginTop: theme.spacing(3),
    marginBottom: theme.spacing(7),
    padding: theme.spacing(2),
    marginTop: 0,
    [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
      marginBottom: theme.spacing(6),
      padding: theme.spacing(4),
      paddingTop: theme.spacing(5),
    },
  },
  footerSpacer: {
    marginTop: '60px',
  },
  inlineFlex: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  category: {
    color: '#f44336',
    marginRight: theme.spacing(2),
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  date: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  dateOverride: {
    fontWeight: 'bold',
  },
  flexEnd: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'flex-end',
  },
  buttonBox: {
    paddingTop: '30px',
    width: '240px',
    marginRight: '-270px',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(850)]: {
      display: 'none',
    },
  },
  relatedPosts: {
    marginTop: theme.spacing(3),
    minHeight: '400px',
  },
  viewAllPostsButton: {
    backgroundColor: 'white',
    border: '1px solid black',
    fontWeight: 'bold',
  },
  viewAllPostsButtonMobile: {
    backgroundColor: 'white',
    border: '1px solid black',
    fontWeight: 'bold',
    width: '100%',
  },
  author: {
    fontStyle: 'italic',
    marginTop: theme.spacing(2),
  },
  authorLink: {
    color: 'inherit',
    textDecoration: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  excerpt: {
    marginTop: theme.spacing(4),
  },
  blogBody: {
    marginTop: theme.spacing(4),
  },
  scrollToTop: {
    position: 'fixed',
    right: '2vw',
    top: '50%',
    bottom: '50%',
  },
  menuNav: {
    position: 'fixed',
    right: '2vw',
    top: '50%',
    bottom: '50%',
    zIndex: 1,
    [theme.breakpoints.up(850)]: {
      display: 'none',
    },
  },
  upArrow: {
    position: 'fixed',
    right: '2vw',
    top: '50%',
    bottom: '50%',
    zIndex: 1,
  },
  navFab: {
  },
  errorState: {
    textAlign: 'center',
  },
  sideBarSectionHeader: {
    padding: theme.spacing(1.0),
    textTransform: 'uppercase',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: 'thin solid lightgrey',
  },
  sideBarSectionHeaderText: {
    fontWeight: '600',
    fontSize: '1.0rem',
  },
  nextPreviousPost: {
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    transitionProperty: 'background-color, box-shadow, border',
    transitionDuration: '250ms, 250ms, 250ms',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1), cubic-bezier(0.4, 0, 0.2, 1), cubic-bezier(0.4, 0, 0.2, 1)',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  sideBarPostTitle: {
    fontSize: '1.2rem',
    fontWeight: '650',
  },
  sideBarPostDateCategory: {
    display: 'flex',
    borderBottom: 'thin solid lightgrey',
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  mobileNav: {
    [theme.breakpoints.up(850)]: {
      display: 'none',
    },
  },
  mobileMenu: {
    padding: '0px',
    width: '240px',
  },
  padRight: {
    paddingRight: theme.spacing(),
  },
});

class BlogPostDetail extends React.Component {
  constructor(props) {
    super(props);
    // Check to see if a post was passed to this component by link.
    // Avoids fetching when we already have the data
    let render = 'loading';
    const { location: { post } } = props;

    if (post) {
      render = 'postDetail';
    }
    this.state = {
      post,
      render,
      sideBarRender: 'loading',
      nextPost: {},
      previousPost: {},
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      anchorEl: null,
      shareDialogOpen: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleMenuOpen = this.handleMenuOpen.bind(this);
    this.getRelatedPosts = this.getRelatedPosts.bind(this);
    this.handleShareDialogOpen = this.handleShareDialogOpen.bind(this);
    this.handleShareDialogClose = this.handleShareDialogClose.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
  }

  componentDidMount() {
    const { post } = this.state;
    if (_.isEmpty(post)) {
      // Grab ID or slug from route
      const { match: { params: { idOrSlug } } } = this.props;
      if (idOrSlug) {
        getBlogPostByIdOrSlug(idOrSlug)
          .then((response) => {
            // console.log('got blog post: ', response.data);
            const blogPost = Array.isArray(response.data) ? response.data[0] : response.data;
            this.setState({ post: blogPost, render: 'postDetail' });
            const { next_post: nextPostId, last_post: previousPostId } = blogPost;
            this.getRelatedPosts(nextPostId, previousPostId);
          }).catch((error) => {
            console.log('unable to fetch blog posts:', error);
            this.setState({
              render: 'errorState',
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: 'Unable to load blog post',
            });
          });
      } else {
        this.setState({
          render: 'errorState',
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'An unknown error occurred',
        });
      }
    } else {
      const { next_post: nextPostId, last_post: previousPostId } = post;
      this.getRelatedPosts(nextPostId, previousPostId);
    }
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { idOrSlug: currentPostId } } } = this.props;
    const { idOrSlug: prevPostId } = prevProps.match.params;

    if (currentPostId !== prevPostId) {
      getBlogPostByIdOrSlug(currentPostId)
        .then((response) => {
          this.setState({ post: response.data, render: 'postDetail' });
          const { next_post: nextPostId, last_post: previousPostId } = response.data;
          this.getRelatedPosts(nextPostId, previousPostId);
        }).catch((error) => {
          console.log('unable to fetch blog posts:', error);
          this.setState({
            render: 'errorState',
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Unable to load blog post',
          });
        });
    }
  }

  getRelatedPosts(nextPostId, previousPostId) {
    if (nextPostId) {
      getBlogPostByIdOrSlug(nextPostId)
        .then((response) => {
          this.setState({ nextPost: response.data, sideBarRender: 'sideBarDetail' });
        }).catch(() => {
          this.setState({ nextPost: {} });
        });
    } else {
      this.setState({ nextPost: {} });
    }
    if (previousPostId) {
      getBlogPostByIdOrSlug(previousPostId)
        .then((response) => {
          this.setState({ previousPost: response.data, sideBarRender: 'sideBarDetail' });
        }).catch(() => {
          this.setState({ previousPost: {} });
        });
    } else {
      this.setState({ previousPost: {} });
    }
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  handleMenuOpen(e) {
    this.setState({ anchorEl: e.currentTarget });
  }

  handleMenuClose() {
    this.setState({ anchorEl: null });
  }

  handleShareDialogOpen() {
    this.setState({ shareDialogOpen: true });
  }

  handleShareDialogClose() {
    this.setState({ shareDialogOpen: false });
  }

  handleCopy(link) {
    navigator.clipboard.writeText(link);
    this.setState({
      snackbarOpen: true,
      snackbarMessage: 'Link Copied',
      snackbarVariant: 'success',
    });
  }

  render() {
    const { classes, location } = this.props;
    const {
      post,
      render,
      snackbarOpen,
      snackbarMessage,
      snackbarVariant,
      nextPost,
      previousPost,
      sideBarRender,
      anchorEl,
      shareDialogOpen,
    } = this.state;

    const blogPostConditionalRender = {
      loading: <LoadingSpinner />,
      postDetail: <PostDetail post={post} handleShareDialogOpen={this.handleShareDialogOpen}/>,
      errorState: <ErrorMessage />,
    };

    const sideBarConditionalRender = {
      loading: <LoadingSpinner />,
      sideBarDetail: <SideBarDetails
        previousPost={previousPost}
        nextPost={nextPost}
        relatedPosts={post ? post.related_posts : []}
        handleMenuClose={this.handleMenuClose}
      />,
      errorState: <SideBarErrorState />,
    };

    return (
      <div className={classes.page}>
        <Helmet>
          <title>Nia Blog - Post</title>
          <meta name="description" content="Experience the magic of Nia through stories and shared experiences provided by our Nia Community." />
        </Helmet>
        <NavBar />
        <NavFab className={classes.navFab} handleMenuOpen={this.handleMenuOpen} handleMenuClose={this.handleMenuClose} />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <div className={classes.flexEnd}>
            <div className={classes.buttonBox}>
              <Button className={classes.viewAllPostsButton} size="large" fullwidth="true" variant="outlined" component={Link} to="/blog">View all posts</Button>
              {render === 'postDetail' && (
                <Paper elevation={2} className={classes.relatedPosts}>
                  {sideBarConditionalRender[sideBarRender]}
                </Paper>
              )}
            </div>
          </div>
          <Paper elevation={2} className={classes.paper}>
            {blogPostConditionalRender[render]}
          </Paper>

          {/* MOBILE MENU */}
          <Menu
            id="menu"
            anchorEl={anchorEl}
            open={!!(anchorEl)}
            onClose={this.handleMenuClose}
            className={classes.mobileNav}
          >
            <div className={classes.mobileMenu}>
              <Button className={classes.viewAllPostsButtonMobile} size="large" fullwidth="true" variant="outlined" component={Link} to="/blog">View all posts</Button>
              {sideBarConditionalRender[sideBarRender]}
            </div>
          </Menu>

          {/* SHARE DIALOG */}
          <ShareDialog
            open={shareDialogOpen}
            link={constructShareLink(location)}
            handleCopy={() => this.handleCopy(constructShareLink(location))}
            handleClose={this.handleShareDialogClose}
          />
          {/* SNACK BAR */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={snackbarOpen}
            autoHideDuration={5000}
            handleClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleClose}
              variant={snackbarVariant}
              message={snackbarMessage}
            />
          </Snackbar>
          <FooterSpacer className={classes.footerSpacer} />
        </main>
        <Footer />
      </div>
    );
  }
}

BlogPostDetail.defaultProps = {
  location: locationdefaultProps,
  match: matchDefaultProps,
};

BlogPostDetail.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  location: locationShape,
  match: matchShape,
};

export default withStyles(styles)(BlogPostDetail);

let LoadingSpinner = ({ classes }) => (
  <div className={classes.loadingSpinner}>
    <CircularProgress color="secondary" />
  </div>
);

LoadingSpinner.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

LoadingSpinner = withStyles(styles)(LoadingSpinner);

// POST DETAIL
let PostDetail = ({ classes, post = {}, handleShareDialogOpen }) => {
  const {
    title,
    author,
    post_date: postDate,
    post_date_text_override: dateOverride,
    excerpt,
    header_img: headerImg,
    category,
  } = post;
  const hasDateOverride = !!dateOverride;

  return (
    <div>
      <img src={headerImg} className={classes.hero} alt="Blog post hero" />
      <Typography variant="h3" className={classes.header}>{title}</Typography>
      <div className={classes.inlineFlex}>
        <Typography className={classes.category}>{category.name}</Typography>
        <Typography
          color="textSecondary"
          className={classNames(hasDateOverride ? classes.dateOverride : classes.date, classes.padRight)}
        >
          {hasDateOverride ? dateOverride : prettifyDate(postDate)}
        </Typography>
        <Button size="small" variant="outlined" color="secondary" onClick={handleShareDialogOpen} endIcon={<ShareIcon />}>Share</Button>
      </div>
      {author.name && (
        <Typography color="textSecondary" className={classes.author}>
          <span>{'by '}</span>
          {author.link ? <a href={author.link} rel="noopener noreferrer" className={classes.authorLink}>{author.name}</a> : <span>{author.name}</span>}
        </Typography>
      )}
      <Typography className={classes.excerpt}>{excerpt}</Typography>
      {/* eslint-disable-next-line react/no-danger */}
      <div className={classes.blogBody} dangerouslySetInnerHTML={createMarkup(post.body)} />
    </div>
  );
};

PostDetail.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  post: postShapeIsRequired.isRequired,
};

PostDetail = withStyles(styles)(PostDetail);

// ERROR MESSAGE (For "can not load posts")
let ErrorMessage = ({ classes }) => (
  <div>
    <Typography variant="h5" className={classes.errorState} color="textSecondary">Whoops! Sorry, we were unable to find that post.</Typography>
  </div>
);

ErrorMessage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

ErrorMessage = withStyles(styles)(ErrorMessage);

let SideBarDetails = ({
  classes,
  nextPost,
  previousPost,
  relatedPosts,
  handleMenuClose,
}) => {
  const nextPostIsEmpty = _.isEmpty(nextPost);
  const previousPostIsEmpty = _.isEmpty(previousPost);
  const relatedPostsIsEmpty = _.isEmpty(relatedPosts);

  return (
    <React.Fragment>
      {!nextPostIsEmpty && (
        <div style={{ borderBottom: (!previousPostIsEmpty || !relatedPostsIsEmpty) && 'thin solid lightgrey' }}>
          <div className={classes.sideBarSectionHeader}>
            <Typography className={classes.sideBarSectionHeaderText} variant="h6" color="textPrimary">Next Post:</Typography>
          </div>
          <Link to={{ pathname: `/blog/${nextPost.id}` }} onClick={handleMenuClose} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className={classes.nextPreviousPost}>
              <Typography className={classes.sideBarPostTitle}>{nextPost.title}</Typography>
              <div className={classes.sideBarPostDateCategory}>
                <Typography className={classes.category} style={{ fontSize: '0.8rem' }}>{nextPost.category.name}</Typography>
                <Typography color="textSecondary" className={classes.date} style={{ fontSize: '0.8rem' }}>{nextPost.post_date}</Typography>
              </div>
              <Typography>{nextPost.excerpt}</Typography>
            </div>
          </Link>
        </div>
      )}
      {!previousPostIsEmpty && (
        <div style={{ borderBottom: !relatedPostsIsEmpty && 'thin solid lightgrey' }}>
          <div className={classes.sideBarSectionHeader}>
            <Typography className={classes.sideBarSectionHeaderText} variant="h6" color="textPrimary">Previous Post:</Typography>
          </div>
          <Link to={{ pathname: `/blog/${previousPost.id}` }} onClick={handleMenuClose} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className={classes.nextPreviousPost}>
              <Typography className={classes.sideBarPostTitle}>{previousPost.title}</Typography>
              <div className={classes.sideBarPostDateCategory}>
                <Typography className={classes.category} style={{ fontSize: '0.8rem' }}>{previousPost.category.name}</Typography>
                <Typography color="textSecondary" className={classes.date} style={{ fontSize: '0.8rem' }}>{previousPost.post_date}</Typography>
              </div>
              <Typography>{previousPost.excerpt}</Typography>
            </div>
          </Link>
        </div>
      )}
      {!relatedPostsIsEmpty && (
        <div>
          <div className={classes.sideBarSectionHeader}>
            <Typography className={classes.sideBarSectionHeaderText} variant="h6" color="textPrimary">Related Posts:</Typography>
          </div>
          {relatedPosts.map(post => (
            <Link to={{ pathname: `/blog/${post.id}` }} onClick={handleMenuClose} style={{ textDecoration: 'none', color: 'inherit' }} key={post.id}>
              <div className={classes.nextPreviousPost}>
                <Typography className={classes.sideBarPostTitle}>{post.title}</Typography>
              </div>
            </Link>
          ))}
        </div>
      )}

    </React.Fragment>
  );
};

SideBarDetails.defaultProps = {
  nextPost: postDefaultProps,
  previousPost: postDefaultProps,
  relatedPosts: [],
};

SideBarDetails.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  nextPost: postShape,
  previousPost: postShape,
  relatedPosts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  })),
  handleMenuClose: PropTypes.func.isRequired,
};

SideBarDetails = withStyles(styles)(SideBarDetails);

let SideBarErrorState = () => (
  <div>
    <Typography color="textsecondary">Unable to load navigation.</Typography>
  </div>
);

SideBarErrorState = withStyles(styles)(SideBarErrorState);

// NAVFAB
let NavFab = ({ classes, className, handleMenuOpen }) => {
  const [activeFab, setActiveFab] = useState('Menu');
  const theme = useTheme();

  const handleScroll = () => {
    if (window.scrollY > 250) {
      if (activeFab !== 'To Top') setActiveFab('To Top');
    } else if (activeFab !== 'Menu') setActiveFab('Menu');
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const handleClickToTopButton = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  const fabs = [
    {
      icon: <UpArrow />,
      toolTip: 'To Top',
      onClick: handleClickToTopButton,
      class: classes.upArrow,
    },
    {
      icon: <Add />,
      toolTip: 'Menu',
      onClick: handleMenuOpen,
      class: classes.menuNav,
    },
  ];

  return (
    <div className={className}>
      {fabs.map(fab => (
        <Zoom
          key={fab.toolTip}
          in={fab.toolTip === activeFab}
          timeout={transitionDuration}
          style={{
            transitionDelay: `${fab.toolTip === activeFab ? transitionDuration.exit : 0}ms`,
          }}
          unmountOnExit
        >
          <Tooltip placement="top" title={fab.toolTip}>
            <Fab aria-label={fab.label} className={fab.class} color="primary" onClick={fab.onClick}>
              {fab.icon}
            </Fab>
          </Tooltip>
        </Zoom>
      ))}
    </div>
  );
};

NavFab.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string.isRequired,
  handleMenuOpen: PropTypes.func.isRequired,
};

NavFab = withStyles(styles)(NavFab);
